import { ENGINE_LABELS, APP_NAME } from "@/config";
import { int, usd, plural, Lines } from "@/components/common";

// One activity event (GET /api/activity), as the handoff's feeds write it: its type word, the detail line (code in
// mono) and its cost. Metadata only: ids, counts, paths, SHAs and money. `names` maps ids to people, objectives and
// projects.
export const TYPE_LABEL = { usage: "Usage", commit: "Commit", file: "File", report: "Report", session: "Session", budget: "Budget" };

const BUDGET_SCOPE = {
  coder_daily: (who) => `${who} reached their daily budget`,
  coder_monthly: (who) => `${who} reached their monthly budget`,
  company: () => "The company reached its monthly budget",
  project: (what) => `${what} reached its monthly budget`,
  objective: (what) => `${what} reached its budget`,
};

export function budgetSentence(e, names) {
  const who = names.people?.[e.ref_id] || names.projects?.[e.ref_id] || names.objectives?.[e.ref_id] || "Someone";
  return `${(BUDGET_SCOPE[e.scope] || BUDGET_SCOPE.objective)(who)}${e.cap_usd != null ? `, ${usd(e.cap_usd)}` : ""}`;
}

// a session event from the audit log: started, submitted, locked (by its coder, or automatically) or ended
export function sessionAction(e) {
  if (e.action === "submitted") return "submitted for review";
  if (e.action === "locked") return e.by === "coder" ? "locked" : e.by === "system" ? "locked automatically" : `locked by ${APP_NAME}`;
  return e.action;
}
export const sessionSentence = (e) => `Session ${e.short_id} ${sessionAction(e)}`;

export function EventDetail({ e, names = {} }) {
  const short = e.short_id || (e.session_id || "").slice(0, 6);
  if (e.type === "usage") return (
    <span className="text-muted-foreground">
      {ENGINE_LABELS[e.engine] || e.engine} · in {int(e.input_tokens)} · out {int(e.output_tokens)} · {short}
    </span>
  );
  if (e.type === "commit") return (
    <span className="text-muted-foreground"><span className="font-mono text-foreground">{(e.sha || "").slice(0, 7)}</span> · {e.message}</span>
  );
  if (e.type === "file") return (
    <span className="text-muted-foreground"><span className="font-mono text-foreground break-all">{e.path}</span> <Lines added={e.added} removed={e.removed} /></span>
  );
  if (e.type === "report") return (
    <span className="text-muted-foreground">
      {short} · {plural(e.files, "file")} +{int(e.added)} −{int(e.removed)}
      {e.flags > 0 && <> · <span className="text-gr-warning">{plural(e.flags, "flag")}</span></>}
    </span>
  );
  if (e.type === "budget") return <span className="text-gr-danger">{budgetSentence(e, names)}</span>;
  if (e.type === "session") return <span className="text-muted-foreground">{sessionSentence(e)}</span>;
  return <span className="text-muted-foreground">{e.detail}</span>;
}

export const eventCost = (e) => (e.type === "usage" ? usd(e.cost_usd) : "—");
export const clock = (iso) => new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
